/**
 * Shared scheduling primitive for the site's date-windowed campaigns
 * (Flash Sale, Launch Event Widget, ...).
 *
 * Every one of these is a published singleton that must switch itself on at a
 * start date and off at an end date without anyone publishing at midnight, so
 * they all answer the same question: is `now` inside [startDate, endDate) while
 * the campaign is enabled?
 */
export interface IScheduledCampaign {
  isEnabled?: boolean;
  startDate?: string;
  endDate?: string;
}

/**
 * The campaign is live when it is enabled AND now is inside
 * [startDate, endDate). Both bounds are required — that is what removes the
 * manual midnight publish. Missing or invalid dates mean "not live", never
 * "live forever".
 */
export function isCampaignWindowLive(
  config: IScheduledCampaign | null | undefined,
  now: number = Date.now(),
): boolean {
  if (!config?.isEnabled) return false;
  if (!config.startDate || !config.endDate) return false;
  const start = new Date(config.startDate).getTime();
  const end = new Date(config.endDate).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end)) return false;
  return start <= now && now < end;
}
